export const AccountChildRoutes = [
  {
    path: 'orders',
    name: 'userorders',
    component: () =>
      import(/* webpackChunkName: "account" */ '@/modules/account/_components/UserOrdersView.vue'),
  },
  {
    name: 'user-change-password',
    path: 'change-password',
    component: () =>
      import(/* webpackChunkName: "account" */ '@/modules/account/_components/ChangePasswordView.vue'),
  },
  {
    name: 'user-edit-data',
    path: 'edit',
    component: () =>
      import(/* webpackChunkName: "account" */ '@/modules/account/_components/ChangeUserDataView.vue'),
  },
]
